import React from 'react';
import { Icon } from 'Permafrost/index';
export function LoadingSpinner(props) {
    const { className, fill, id, size, style, ariaLabel = 'Loading...' } = props;
    const loaderSize = size || '12px';
    const loaderStyle = Object.assign({ position: 'relative', top: '1px' }, style);
    return (React.createElement(Icon, { name: "fa-circle-notch", className: `spin ${className || ''}`, "data-cy": props['data-cy'], id: id, size: [loaderSize], style: loaderStyle, fill: fill || 'currentColor', ariaLabel: ariaLabel }));
}
//# sourceMappingURL=LoadingSpinner.js.map